import { Tooltip, Typography } from '@mui/material';
import React, { FC, useState } from 'react';

import { TDownloadButton } from './DownloadButton.types';

import { FlashMessageType } from '../../const';
import { generateReportLink } from '../../utils';
import FlashMessageCreate from '../FlashMessage';

const DownloadButton: FC<TDownloadButton> = ({ link, children, loadingText, tooltipText, disabled }) => {
  const [loading, setLoading] = useState(false);

  const onClick = () => {
    setLoading(true);
    generateReportLink(link, 'get')
      .then(([content, fileName]) => {
        const linkElement = document.createElement('a');
        linkElement.href = content as string;
        linkElement.setAttribute('download', fileName as string);
        linkElement.click();

        // Release URL object, remove html element, set preview button to default view.
        window.URL.revokeObjectURL(content as string);
        linkElement.remove();
      })
      .catch(([_, __, message]) => {
        FlashMessageCreate({ message, type: FlashMessageType.Error, isSelfDestroyable: true });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Tooltip
      title={
        tooltipText ? (
          <Typography maxWidth={'17rem'} sx={{ fontSize: '14px' }}>
            {tooltipText}
          </Typography>
        ) : (
          ''
        )
      }
      placement={'bottom'}
      arrow
    >
      <span>
        <button
          className={`btn btn--main btn--fix ${loading ? 'btn--loading' : ''} ${disabled ? 'btn--disabled' : ''}`}
          type='button'
          disabled={disabled || loading}
          onClick={onClick}
        >
          {loading ? loadingText : children}
        </button>
      </span>
    </Tooltip>
  );
};

export default DownloadButton;
